/**
 * POS roles and what each one can do.
 * The restaurant owner (business_owner) is always a manager in the POS.
 * Firestore rules enforce the same split (firestore.rules → posRoleIn).
 */
export const POS_ROLES = [
  { value: 'manager', label: 'مدير' },
  { value: 'cashier', label: 'كاشير' },
  { value: 'waiter', label: 'ويتر' },
  { value: 'kitchen', label: 'مطبخ' }
]

const PERMS = {
  // waiters open the order screen to send orders to tables; paying needs `collect`
  sell: ['manager', 'cashier', 'waiter'],
  collect: ['manager', 'cashier'],
  shift: ['manager', 'cashier'],
  tables: ['manager', 'cashier', 'waiter'],
  kitchen: ['manager', 'cashier', 'kitchen'],
  orders: ['manager', 'cashier'],
  discount: ['manager', 'cashier'],
  cancel: ['manager'],
  noShow: ['manager'],
  staff: ['manager'],
  settings: ['manager'],
  reports: ['manager']
}

export function posRoleLabel(role) {
  return POS_ROLES.find((r) => r.value === role)?.label || role || '—'
}

export function currentPosRole() {
  const role = localStorage.getItem('role')
  if (role === 'business_owner') return localStorage.getItem('posEnabled') === 'true' ? 'manager' : ''
  if (role === 'pos_staff') return localStorage.getItem('posRole') || ''
  return ''
}

export function posCan(perm, role = currentPosRole()) {
  return !!role && (PERMS[perm] || []).includes(role)
}

/** First POS screen for a role. */
export function posHomePath(role = currentPosRole()) {
  if (role === 'kitchen') return '/pos/kitchen'
  if (role === 'waiter') return '/pos/tables'
  return '/pos/sell'
}

/** Who is using the POS right now (for createdBy / paidBy fields). */
export function currentPosUser() {
  const role = localStorage.getItem('role')
  if (role === 'pos_staff') {
    return {
      id: localStorage.getItem('posStaffId') || '',
      name: localStorage.getItem('posStaffName') || 'موظف',
      role: localStorage.getItem('posRole') || ''
    }
  }
  return {
    id: `owner:${localStorage.getItem('ownerAccountDocId') || ''}`,
    name: localStorage.getItem('businessDisplayName') || 'المدير',
    role: 'manager'
  }
}
